<template>
  <div>
    <b-alert v-if="showType === 'header' && !hideTopBanner" variant="info" show>
      <div class="header">
        <strong>Add us to your Device</strong>
        <p>
          Install our customer portal to your device home screen for easy access
        </p>
        <div>
          <b-button
            @click="install"
            class="header-btn"
            size="sm"
            variant="success"
            >Install Now</b-button
          >
          <b-button @click="dismiss" class="header-btn" size="sm"
            >Dismiss</b-button
          >
        </div>
      </div>
    </b-alert>

    <div v-if="showType === 'account' && !hideAccountOption">
      <div style="font-size: 2rem;">
        <b-icon-phone size="lg" style="color: #8dc04c;">Account</b-icon-phone>
      </div>
      <h5>Install on Device</h5>

      <p>Bookmark our portal on your device home screen</p>

      <b-button
        @click="install"
        class="account-btn"
        size="sm"
        variant="outline-success"
        >Install</b-button
      >
    </div>

    <b-modal id="ios-modal" hide-footer hide-header-close>
      <template #modal-title>
        Install Bookmark for Apple iOS
      </template>
      <div class="d-block text-center" style="text-align: left">
        <h5 style="text-align: left">
          Add our customer portal to your phone home screen
        </h5>
        <ul style="text-align: left">
          <li>Open our customer portal in Safari or Chrome</li>
          <li>
            Click the 'share' icon <b-icon-box-arrow-up></b-icon-box-arrow-up>
          </li>
          <li>Click 'Add to Home Screen'</li>
          <li>
            Voila! You'll now be able to easily access your portal from your
            phone home screen!
          </li>
        </ul>
      </div>
      <b-button class="mt-3" block @click="$bvModal.hide('ios-modal')"
        >Close</b-button
      >
    </b-modal>
    <b-modal id="dismiss-modal" hide-footer hide-header-close>
      <template #modal-title>
        Preferences Updated
      </template>
      <div class="d-block text-center" style="text-align: left">
        <p>
          You can install the device on your home screen by accessing your
          account dashboard
        </p>
      </div>
      <b-button class="mt-3" block @click="$bvModal.hide('dismiss-modal')"
        >Close</b-button
      >
    </b-modal>
  </div>
</template>

<script>
import { BIconPhone } from "bootstrap-vue";
import { BIconBoxArrowUp } from "bootstrap-vue";

export default {
  name: "InstallPWA",
  components: { BIconPhone, BIconBoxArrowUp },
  props: {
    showType: {
      type: String,
      required: true,
      validator: function(value) {
        return ["header", "account"].includes(value);
      }
    }
  },
  computed: {
    getPrompt() {
      return this.$store.state.auth.installPrompt;
    },
    isStandalone() {
      return this.$store.state.auth.isStandalone;
    },
    isInstallActioned() {
      return localStorage.getItem("pwa_install");
    },
    hideTopBanner() {
      return (
        this.isStandalone ||
        this.hideInstallBanner ||
        this.isInstallActioned ||
        (!this.getPrompt && !this.isIos)
      );
    },
    hideAccountOption() {
      return (
        this.isStandalone ||
        this.hideInstallBanner ||
        (!this.getPrompt && !this.isIos)
      );
    }
  },
  data() {
    return {
      installed: false,
      hideInstallBanner: false,
      isIos: false
    };
  },
  created() {
    this.runSetup();
  },
  methods: {
    setupListeners() {
      window.addEventListener("appinstalled", () => {
        this.$gtag.event("pwa_install");
        this.$store.dispatch("setInstallPrompt", {
          prompt: null
        });
        this.installed = true;
        this.hideInstallBanner = true;
        localStorage.setItem(
          "pwa_install",
          JSON.stringify({ installed: new Date() })
        );
      });
    },
    runSetup() {
      const userAgent = window.navigator.userAgent.toLowerCase();
      this.isIos = /iphone|ipad|ipod/.test(userAgent);

      this.setupListeners();
    },
    async install() {
      if (this.isIos) {
        this.$gtag.event("pwa_ios_install");
        this.$bvModal.show("ios-modal");
        return;
      }
      this.getPrompt.prompt();
    },
    async dismiss() {
      localStorage.setItem(
        "pwa_install",
        JSON.stringify({ dismissed: new Date() })
      );

      this.$gtag.event("pwa_dismiss");

      this.hideInstallBanner = true;
      this.$bvModal.show("dismiss-modal");
    }
  }
};
</script>

<style scoped lang="scss">
h5 {
  font-size: 1.1rem;
  font-weight: bold;
}

p {
  font-size: 0.9rem;
}

.btn.account-btn {
  border: 2px solid #8dc04c;
  background: #8dc04c;
  color: white;
  margin: 6px 6px;
}

.header {
  .btn.header-btn {
    margin: 6px 6px;
  }
}
</style>
